import { render, staticRenderFns } from "./NotifCommentMyPost.vue?vue&type=template&id=0ece2fee&scoped=true"
import script from "./NotifCommentMyPost.vue?vue&type=script&lang=js"
export * from "./NotifCommentMyPost.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=0ece2fee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece2fee",
  null
  
)

export default component.exports